import { Injectable } from '@angular/core';
import { AnalyticsService, IUniversalDataLayer } from '@rogers/analytics';
import { CONSTANT } from '../constants/constant';

@Injectable({
  providedIn: 'root',
})
export class RchAnalyticsService {
  dataLayer: IUniversalDataLayer | undefined;
  constructor(private analyticsService: AnalyticsService) {}

  public rchTrackPageLoad() {
    this.dataLayer = this.constructDataLayer();
    this.dataLayer = { ...this.dataLayer, events: { pageView: true } };
    this.analyticsService.trackPageLoad(this.dataLayer);
  }

  public rchTrackError(errorPayload: any) {
    this.dataLayer = this.constructDataLayer();
    const errorData = this.getErrorAnalyticsPayload(
      errorPayload?.status?.toString(),
      errorPayload?.code?.toString());
    this.dataLayer = {
      ...this.dataLayer,
      events: { error: true },
      errors: [{ ...errorData }],
    };
    this.analyticsService.trackPageLoad(this.dataLayer);
  }

  private constructDataLayer() {
    return {
      applicationName: CONSTANT.analyticsConstant.applicationName,
      events: { error: true },
      page: {
        name: CONSTANT.analyticsConstant.page.name,
        hierarchy: CONSTANT.analyticsConstant.page.hierarchy,
        language: CONSTANT.analyticsConstant.page.language,
        province: CONSTANT.analyticsConstant.page.province,
      },
      site: { name: CONSTANT.analyticsConstant.site.name },
    };
  }

  getErrorAnalyticsPayload(
    errorHeader: string,
    errorCode: string
  ) {
    return {
      category: CONSTANT.analyticsConstant.category,
      type: CONSTANT.analyticsConstant.user,
      code: errorCode,
      API: '',
      message: errorHeader,
      field: '',
    };
  }
}
